// export const OauthGoogle = {
//   clientId: "770477268044-5a8kf2ic03pihfdcffvqblen2d84j8c3.apps.googleusercontent.com",
//   secretClient: "qAxLgG18hszGW1Kt2mXwayVx"
// }

export const apiKey = "AIzaSyBTHElEsbB1vTSvlutjbciCQHvATV7Eip4"